module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_location@2x-34325701aaf79e5dcdf6fb3cb79509f6.webp";